/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/redirect': {
    width: 66,
    height: 66,
    viewBox: '0 0 66 66',
    data: '<path pid="0" d="M0 33c0 18.225 14.775 33 33 33s33-14.775 33-33S51.225 0 33 0 0 14.775 0 33z" _fill="#fff"/><path pid="1" d="M52.09 32.188L36.094 15.53H27.05l12.799 13.33H14.235v6.666h25.613l-12.8 13.33h9.046L52.09 32.188z" _fill="#E25046"/>'
  }
})
